import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { divIcon, icon, Map, marker, tileLayer } from 'leaflet';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentService } from '../../services/content.service';
import { GetContentsRequest } from 'src/app/models/getContentsRequest';
import { ContentsResults } from 'src/app/models/contentResults';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { TypeContents } from '../../models/typeContents';
import { IonModal, IonSearchbar, ModalController } from '@ionic/angular';
import { DepartmentModal } from '../../modals/department-moda';
import { DateHelper } from 'src/app/helpers/date.helper';
import { PlaceEventsComponent } from 'src/app/modals/place-events/place-events.component';
import { LocationAccuracy } from '@awesome-cordova-plugins/location-accuracy/ngx';
import { LoadDataService } from '../../services/load-data.service';
import { ResultPlace } from '../../models/contentResults';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.page.html',
  styleUrls: ['./search-page.page.scss'],
})
export class SearchPagePage implements OnInit {

  @ViewChild('modalFilters') modalFilters: IonModal;
  @ViewChild(IonSearchbar) searchInput: IonSearchbar;
  @Input() placeholder: string;
  
  // Filtros
  filtro = null;
  filtroName = '';
  filtroUbicacion = null;
  filtroFecha = null;
  filtroExperiencia = null;
  selectedFiltersName: string[] = [];

  searchTxt = '';
  tagId = 0;
  dapartmentId = null;

  dateFrom = '';
  dateTo = '';

  pagina = 0;
  canShowMore = true;
  limit = 4;

  // Resultados
  results: ContentsResults[] = [];

  // Contents
  typeContents: TypeContents[] = [];

  // Geolocations
  userCoords = {} as GeolocationCoordinates;

  // searcher
  onSearch = false;
  onFilter = false;
  searchResults = [];
  searchResultLength = null

  // Resultados de lugares
  showResultsPlace : ResultPlace[] = [];
  allResultsPlace : ResultPlace[] = [];
  idxInitialShowPlace = 0;
  idxFinalShowPlace = 5;

  // Resultados de contenidos
  showResultsContent : ResultPlace[] = [];
  allResultsContent : ResultPlace[] = [];
  idxInitialShowContent = 0;
  idxFinalShowContent = 5;

  // Resultados de tags
  showResultsTag : ResultPlace[] = [];
  allResultsTag : ResultPlace[] = [];
  idxInitialShowTag = 0;
  idxFinalShowTag = 5;

  // Resultados de contenidos filtrados
  showResultsFilterContent : ContentsResults[] = [];
  allResultsFilterContent : ContentsResults[] = [];
  idxInitialShowFilterContent = 0;
  idxFinalShowFilterContent = 5;

  constructor(
    public loadDataService: LoadDataService,
    private activatedRoute: ActivatedRoute,
    private contentService: ContentService,
    private geolocation: Geolocation,
    private modalCtrl: ModalController,
    private locationAccuracy: LocationAccuracy,
    private router: Router
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {

    this.setUserCoords();

    this.contentService.getContainer("MAIN")
          .subscribe( (resp:any) => {
            console.log( resp );
            this.typeContents = resp.children;

            setTimeout(() => { 
              console.log('timeout')
              this.searchInput.setFocus(); 
            }, 500);
          })
    // this.contentService.getContentsTypes()
    //     .subscribe ( (resp: TypeContents[] ) => this.typeContents = resp )

  }

  ionViewWillLeave() {
    // this.cleanSearch();
    // this.clearFilters();

    // // limpiar variables
    // this.searchTxt = '';
    // this.tagId = 0;
    // this.dapartmentId = null;

    // this.dateFrom = '';
    // this.dateTo = '';

    // this.pagina = 0;
    // this.canShowMore = true;
    // this.limit = 4;
  }

  getMore() {
    this.pagina ++;
    this.filters(false);
  }

  getMoreOfSearch(type: string) {
    if ( type === 'place' ) {
      this.idxFinalShowPlace = this.idxFinalShowPlace + 5;
      this.showResultsPlace = this.allResultsPlace.slice(this.idxInitialShowPlace, this.idxFinalShowPlace);
    } else if ( type === 'content' ) {
      this.idxFinalShowContent = this.idxFinalShowContent + 5;
      this.showResultsContent = this.allResultsContent.slice(this.idxInitialShowContent, this.idxFinalShowContent);
    } else if ( type === 'content-filter' ) {
      this.idxFinalShowFilterContent = this.idxFinalShowFilterContent + 5;
      this.showResultsFilterContent = this.allResultsFilterContent.slice(this.idxInitialShowFilterContent, this.idxFinalShowFilterContent);
    } else if ( type === 'tag' ) {
      this.idxFinalShowTag = this.idxFinalShowTag + 5;
      this.showResultsTag = this.allResultsTag.slice(this.idxInitialShowTag, this.idxFinalShowTag);
    }
  }

  setUserCoords() {
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {

      if(canRequest) {
        // the accuracy option will be ignored by iOS
        this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
          () => {
            console.log('GPS Request successful');

            this.geolocation.getCurrentPosition().then( (resp) => {
              this.userCoords = resp.coords;
            });
          })
      }
    });
  }

  changeFilter( type: number, filtro: any, tagName?: string ) {
    console.log( type )
    console.log( filtro )
    switch (type) {
      case 0:
        this.filtro = filtro;
        this.filtroName = tagName;
        break;
      case 1:
        this.filtroUbicacion = filtro;
        this.setUserCoords();
        filtro === 'ubicacion' ? this.openModal() : null;
        break;
      case 2:
        this.filtroFecha = filtro;
        if (filtro == 2) {
          this.dateFrom = DateHelper.toString(DateHelper.today())
          this.dateTo = DateHelper.toString(DateHelper.sevenDays())
        } else if (filtro == 3) {
          this.dateFrom = DateHelper.toString(DateHelper.sevenDays())
          this.dateTo = DateHelper.toString(DateHelper.fourteenDays())
        }
        break;
      case 3:
        this.filtroExperiencia = filtro;     
        break;
    }
  }

  thereIsFilter() {
    if( this.filtro || this.filtroExperiencia || this.filtroUbicacion || this.filtroFecha ) {
      return true;
    } else {
      return false;
    }
  }

  fltrarThisWeek() {
    this.dateFrom = DateHelper.toString(DateHelper.today());
    this.dateTo = DateHelper.toString(DateHelper.sevenDays());
    this.filtroFecha = 'esta';
    this.searchTxt = '';
    this.filters( true );
  }

  filtrarVirtual(){
    this.filtroExperiencia = 'Virtual';
    this.searchTxt = '';
    this.filters( true );
  }

  clearFilters() {
    this.filtro = null;
    this.filtroName = '';
    this.filtroUbicacion = null;
    this.filtroFecha = null;
    this.filtroExperiencia = null;
    this.dateTo = '';
    this.dateFrom = '';
    // this.searchTxt = '';
  }

  goToTags( tagId, tagName ) {
    this.router.navigate(['/navigator/results', tagId, tagName])
  }


  search(e) {
    const key = e.target.value;
    this.searchTxt = key;

    if ( key.length <= 3 ) {
      this.searchResults = [];
      this.onSearch = false;
      return;
    }
    if ( key.length > 3 ) {
      this.searchRequest( key );
    }
  }

  searchRequest( key ) {

      this.idxFinalShowPlace = 5;
      this.idxFinalShowContent = 5;
      this.idxFinalShowTag = 5;

      if ( !this.onFilter ) {
        this.contentService.search( key ).subscribe( (resp: any) => {
          this.onSearch = true;
          this.searchResults = resp;
          console.log( this.searchResults )
          this.searchResultLength = this.searchResults[0].result.length + this.searchResults[1].result.length + this.searchResults[2].result.length;

          // Seteo de resultados de lugares para mostrar
          this.allResultsPlace  = this.searchResults[2].result;
          this.showResultsPlace = this.allResultsPlace.slice( this.idxInitialShowPlace, this.idxFinalShowPlace);
          
          // Seteo de resultados de contenidos para mostrar
          this.allResultsContent  = this.searchResults[0].result;
          this.showResultsContent = this.allResultsContent.slice( this.idxInitialShowContent, this.idxFinalShowContent);

          // Seteo de resultados de tags para mostrar
          this.allResultsTag  = this.searchResults[1].result;
          this.showResultsTag = this.allResultsTag.slice( this.idxInitialShowTag, this.idxFinalShowTag);
        })
      } else {
        this.filters(true);
      }

  }

  cleanSearch() {
    this.onSearch = false;
  }

  modalOpen() {
    this.modalFilters.present();
  }

  filters( resetResult ) {

    this.idxFinalShowFilterContent = 5;

    resetResult ? this.results = [] : null;

    this.modalFilters.dismiss();

    this.activatedRoute.params.subscribe(params => {
      console.log(params);
      // this.searchTxt = params.tagName
      this.contentService.getContents({
        tagId: params.tagId,
        ancestorId: this.filtro,
        lon: this.userCoords.longitude ? this.userCoords.longitude.toString() : null,
        lat: this.userCoords.latitude ? this.userCoords.latitude.toString() : null,
        maxDistance: this.filtroUbicacion,
        departamentId: this.dapartmentId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        eventType: this.filtroExperiencia,
        text: this.searchTxt,
        offset: this.pagina,
        limit: 100
      } as GetContentsRequest)
      .subscribe( (resp: ContentsResults[]) => {
        console.log( resp )
        this.onFilter = true;
        this.onSearch = false;
        // this.results = resp;

        // resp.forEach( x => this.results.push( x ) )
        // resp.length === this.limit ? this.canShowMore = true : this.canShowMore = false;

        // Seteo de resultados de contenidos filtrados para mostrar
        this.allResultsFilterContent  = resp;
        this.showResultsFilterContent = this.allResultsFilterContent.slice( this.idxInitialShowFilterContent, this.idxFinalShowFilterContent);

        this.searchResultLength = resp.length;
        this.searchResultLength === 0 ? this.clearFilters() : null;
      })

    });
  }

  goToMap(type: string) {

    const filters = {
        contentTypeName : this.filtroName,
        contentTypeId: this.filtro,
        lon: this.userCoords.longitude ? this.userCoords.longitude.toString() : null,
        lat: this.userCoords.latitude ? this.userCoords.latitude.toString() : null,
        maxDistance: this.filtroUbicacion,
        departamentId: this.dapartmentId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        fechaFilter: this.filtroFecha,
        eventType: this.filtroExperiencia,
    }
    this.router.navigate(['/navigator/map-result', this.searchTxt, type, filters])
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: DepartmentModal,
      cssClass: 'transparent-modal'
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      console.log(data)
      this.dapartmentId = data;
    }
  }

}
